import { render, staticRenderFns } from "./edit-personal-policy-form.vue?vue&type=template&id=72ef66ac&scoped=true&"
import script from "./edit-personal-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-personal-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ef66ac",
  null
  
)

export default component.exports